// veutify plugin file https://vuetifyjs.com/en/getting-started/quick-start#webpack-install
import Vue from 'vue';
import Vuetify from 'vuetify';
import VCalendar from 'v-calendar';

Vue.use(Vuetify);
Vue.use(VCalendar, {componentPrefix: 'vc'});

const opts = {
  icons: {
    iconfont: 'fa',
    values: {
      checkboxOff: 'fa fa-square-o',
      dropdown: 'fal fa-chevron-down',
      warning: 'fas fa-circle-exclamation',
      info: 'fas fa-circle-info',
      error: 'fas fa-circle-x',
      success: 'fas fa-circle-check',
    }
  }
};

export default new Vuetify(opts);
